class RadioButton extends HTMLElement {
  selected = null;
  constructor() {
    super();

    const inputs = this.querySelectorAll("input[type='radio']");

    inputs.forEach((input) =>
      input.addEventListener('change', (e) => {
        this.selected = input.id;

        this.checkSelectedContainer();
      })
    );
  }

  connectedCallback() {
    const inputs = this.querySelectorAll("input[type='radio']");

    inputs.forEach((input) => {
      if (input.checked) {
        this.selected = input.id;
        this.checkSelectedContainer();
      }
    });
  }

  checkSelectedContainer() {
    const containers = this.querySelectorAll('.radio-button-container');

    containers.forEach((container) => {
      if (container.classList.contains(this.selected)) {
        container.classList.add('product-variant-option--checked');
      } else {
        container.classList.remove('product-variant-option--checked');
      }
    });
  }
}

customElements.define('radio-button', RadioButton);